// libraries
import React from "react";

// components
import Content from "../../components/CreateEvent/Content/Content";

const index = () => {
  return <Content />;
};

export default index;
